const { DataServiceEndPoint } = require("@cloudbreakus/network-utilities")

class SSE extends DataServiceEndPoint {
  static key = "SSE"

  getSubscriptionUrl = () => {
    if (this._config.get("sse.v2.dynamic.useAlternativeNotificationUrl")) {
      return `${this.url}/v1/subscriptions/dynamic`
    }

    return `${this._config.get("sse.v2.dynamic.url")}/subscriptions/v2`
  }

  subscribe = (payload) => {
    return this._httpService.put(this.getSubscriptionUrl(), payload, {
      headers: { Authorization: `bearer ${this.token}` },
    })
  }

  unsubscribe = (data) => {
    return this._httpService.delete(this.getSubscriptionUrl(), {
      headers: { Authorization: `bearer ${this.token}` },
      data,
    })
  }

  closeDynamicConnection = (emitterHash) => {
    if (emitterHash == null || emitterHash === "") {
      return Promise.resolve()
    }
    const id = encodeURIComponent(emitterHash)
    const useApiProxy = this._config.get("sse.v2.dynamic.useAlternativeNotificationUrl")
    const url = useApiProxy
      ? `${this.url}/v1/subscriptions/dynamic/${id}`
      : `${this._config.get("sse.v2.dynamic.url")}/connect/${id}`
    return this._httpService.delete(url, {
      headers: { Authorization: `bearer ${this.token}` },
    })
  }
}

module.exports = SSE
